export default {
  content: `<p>
    <strong>The development of computing power in the United States has entered a "super capital mobilization period" driven by both tech giants and national strategy, firmly maintaining its leading position in global computing power总量</strong>. Relying on Silicon Valley's innovation ecosystem and strong capital strength, the US is achieving complete localization of the software and hardware supply chain through the CHIPS and Science Act, while facing the "grid bottleneck" and new geopolitical challenges brought by the rapid expansion of computing power.
</p>
<p>
    <span style="font-size: 18px;"><strong>Current Status of Computing Power Development</strong></span>
</p>
<ul class=" list-paddingleft-2" style="list-style-type: disc;">
    <li>
        <p>
            <strong>Unprecedented Supercluster Scale</strong>: As of 2026, the US still holds nearly three-quarters of the world's advanced AI computing clusters, maintaining absolute dominance in existing capacity. The total capacity of planned data center projects across the US has reached 245 gigawatts (GW).
        </p>
    </li>
    <li>
        <p>
            <strong>Capital Expenditure Breaks Historical Records</strong>: In the race for Artificial General Intelligence (AGI), the infrastructure capital investment of just four major US tech giants (Microsoft, Amazon, Google, Meta) is expected to surge to approximately $670 billion in 2026, accounting for about 2% of US GDP. Computing power construction is welcoming the largest investment super-cycle in history.
        </p>
    </li>
    <li>
        <p>
            <strong>Supply Chain Localization Enters the "Realization Period"</strong>: Driven by the <span style="color: #548DD4;">CHIPS and Science Act</span>, the government has distributed over $33 billion in direct grants to 35 companies. For example, photonics giant <span style="color: #548DD4;">Coherent received a $50 million grant</span> to expand the production capacity of high-speed optical interconnect chips for AI data centers at its Texas facility by 4 times.
        </p>
    </li>
    <li>
        <p>
            <strong>Facing the Severe "Transformer and Grid Wall"</strong>: Due to the surge in data center power consumption, <span style="color: #548DD4;">Goldman Sachs research shows</span> that the electricity demand of US data centers will double from 31GW in 2025 to 66GW by 2027. Traditional data center-intensive states such as Virginia and Georgia have seen legal restrictions or grid connection delays due to grid overload.
        </p>
    </li>
</ul>
<p>
    <br/>
</p>`,
};